"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Check } from "lucide-react";
export default function PortStanley() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235399" id="treatment-details" className="bg-background text-foreground py-24 overflow-hidden">
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex flex-col items-start gap-6 md:pr-8">
            
            
            <h2 className="font-default text-4xl font-bold leading-tight !text-[rgba(76,185,205,1)] md:text-5xl lg:text-6xl">28 Minuten für optimale Ergebnisse</h2>
            
            <div className="space-y-6">
              <p className="text-lg text-muted-foreground leading-relaxed font-default">
                EMP Chair Pro hilft Ihnen, Beckenbodenbeschwerden wie Inkontinenz, Rückenschmerzen oder Libidoverlust effektiv zu lindern. Ganz bequem im Sitzen, ohne Eigenaufwand und vollständig schmerzfrei.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-primary shrink-0 mt-1" />
                  <span className="text-lg text-muted-foreground font-default">Über 12.000 Kontraktionen in nur 28 Minuten</span>
                </div>
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-primary shrink-0 mt-1" />
                  <span className="text-lg text-muted-foreground font-default">Vollständig bekleidet, ganz ohne eigenes Training</span>
                </div>
                <div className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-primary shrink-0 mt-1" />
                  <span className="text-lg text-muted-foreground font-default">Trainiert alle 3 Muskelschichten des Beckenbodens völlig schmerzfrei</span>
                </div>
              </div>
            </div>
            
            <Button variant="outline" size="lg" className="bg-background inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs h-10 px-6 has-[>svg]:px-4 mt-4 rounded-md border-primary/20 text-primary font-default !bg-[rgba(163,211,228,1)] !font-extrabold disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-primary/5" asChild>
              <Link to="/SolutionsSubpagesAdditionalTreatmentsPage">
                Jetzt Probesitzen vereinbaren!
              </Link>
            </Button>
          </div>

          <div className="relative w-full">
            <div className="aspect-[4/3] overflow-hidden rounded-lg shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/emp_chair.png-wvc-sizes" alt="Der innovative EMP Chair für Beckenbodentraining" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one_mw-scaled.jpg" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}